<section (click)="details.emit()">
	<p>
		<span class="bodyPart" [attr.data-test]="woundCare.bodyPart">
			{{ woundCare.category.name | language }} - {{ "wound_care.body." + woundCare.bodyPart | translate }}
		</span>
		<small> {{ "wound_care.active_since" | translate }}: {{ woundCare.creationDate | date: "dd/MM/yy  HH:mm" }} </small>
	</p>
	<ul>
		@for (picture of woundCarePictures; track picture) {
			<li (click)="pictures.emit()">
				<ic-image data-test="wound-thumbnail" [src]="picture.thumb || picture.filename | safeBlob" />
			</li>
		}
	</ul>
</section>
